<script setup lang="ts">
import { usePaymentMethods } from "~/composables/usePaymentMethods";

const { paymentMethodData, fetchPaymentMethods } = usePaymentMethods();

const openItems = ref<Record<string, boolean>>({
  paymentMethodsSection: false,
});

const toggleCollapse = (id: string) => {
  const isCurrentlyOpen = openItems.value[id];

  for (const key of Object.keys(openItems.value)) {
    openItems.value[key] = false;
  }

  openItems.value[id] = !isCurrentlyOpen;
};

onMounted(() => {
  nextTick(() => fetchPaymentMethods());
});
</script>

<template>
  <footer class="bg-primary/5 text-grey-700 mt-auto">
    <FormsSwNewsletterFormFooter />

    <LayoutFooterHorizontalLine />

    <div class="footer-inner">
      <div class="container">
        <div class="footer-columns accordion pt-0 md:pt-16 grid grid-cols-1 md:grid-cols-2 xl:grid-cols-4 gap-4 md:gap-10 xl:gap-6 2xl:gap-0">
        
          <!-- Customer Service Column -->
          <LayoutFooterCustomerService />

          <!-- Footer Dynamic menu (desktop) / Payment methods accordion (mobile) -->
          <LayoutFooterNavigationMenu  :openItems="openItems" :toggleCollapse="toggleCollapse" />
          <LayoutFooterPaymentMethodsMobile :openItems="openItems" :toggleCollapse="toggleCollapse" :payment-method-data="paymentMethodData" />

        </div>

        <!-- Social Media and Payment Methods -->
        <div class="social-media mt-12 pb-0 md:pb-16">
          <div class="grid grid-cols-1 md:grid-cols-2 gap-8 text-center md:text-left">

            <!-- Social Media -->
            <LayoutFooterSocialMedia />

            <!-- Payment Methods -->
            <LayoutFooterPaymentMethods :payment-method-data="paymentMethodData" />
            
          </div>
        </div>

      </div>
    </div>

    <LayoutFooterHorizontalLine />

    <!-- Copyright -->
    <LayoutFooterCopyright />

    <!-- Back to top button -->
    <LayoutFooterBackToTop />

  </footer>
</template>
